export default {
  data() {
    return {
      investigator: {
        person: {
          id_number: {
            type: ""
        }
      }
    },
      rules: {
        osPincodeRules: [
          v =>
            v === null ||
            v === undefined ||
            v === "" ||
            /^[0-9]{4,6}$/.test(String(v)) ||
            this.$t("forms.field.validation.os_pincode.format")
        ],
        nameRules: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 40) || this.$t('forms.field.validation.name.format'),
        ],
        usernameRules: [
          v => ( v === null || v === undefined || v === "" || /^[a-z0-9.]*$/.test(v))
              || this.$t('forms.field.validation.username.format'),
        ],
        alarmCodeRules: [
          v => ( v === null || v === undefined || v === "" || /^\d{4}$/i.test(v) ),
        ],
        youtubeIDRules: [
          v => ( v === null || v === undefined || v === "" || /^[a-zA-Z0-9_-]{11}$/.test(v) )
        ],
        checkboxRequired: [v => v !== "" || this.$t('forms.field.validation.required')],
        fieldRequired: [v => !!v || this.$t('forms.field.validation.required')],
        uriRules: [
          v => ( v === null || v === undefined || v === "" || /^.+:[/]{2}.+$/.test(v))
              || this.$t('forms.field.validation.uri.format'),
        ],
        issnRules: [
          v => ( v === null || v === undefined || v === "" || /^[0-9]{4}[-][0-9]{4}$/.test(v))
              || this.$t('forms.field.validation.issn.format'),
        ],
        doiRules: [
          v => ( v === null || v === undefined || v === "" || /^10.\d{4,9}\/[-._;()/:A-Z0-9]+$/i.test(v) ) || this.$t('forms.field.validation.doi.format'),
        ],
        isoDateTime: [
          v => (
            v === null ||
            v === undefined ||
            v === '' ||
            /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(Z|[+-]\d{2}:\d{2})?$/.test(v)
          ) || this.$t('forms.field.validation.isoDatetime')
        ],
        projectcodeRules: [
          v => ( v === null || v === undefined || v === "" || /^[-._;()/:A-Z0-9]+$/i.test(v) ) || this.$t('forms.field.validation.projectcode.format'),
        ],
        isbnRules: [
          v => (!v || v === '' || v.length <= 17 && v.length >= 13) || this.$t('forms.field.validation.isbn.format'),
        ],
        macRules: [
          v => !!v || this.$t('forms.field.validation.required'),
            v => /^((\d|([a-f]|[A-F])){2}:){5}(\d|([a-f]|[A-F])){2}$/.test(v) || this.$t('forms.field.validation.mac.format')
        ],
        ipRules: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => /^(\d{1,3}\.){3}(\d){1,3}$/.test(v) || this.$t('forms.field.validation.ip.format')
        ],
        numAuthorsRules: [
          v => (!!v && (typeof v !== 'number' || !isNaN(v))) || this.$t('forms.field.validation.validInteger'),
          v => v > 0 || this.$t('forms.field.validation.numAuthors.positive')
        ],
        nextcloudquotaRules: [
          v => (!!v && (typeof v !== 'number' || !isNaN(v))) || this.$t('forms.field.validation.validInteger'),
          v => v >= 0 || this.$t('forms.field.validation.nextcloudquota.tooLow'),
          v => v <= 5000 || this.$t('forms.field.validation.nextcloudquota.tooHigh')
        ],
        numPagesRules: [
          v => ( v === null || v === undefined || v === "" || v > 0) || this.$t('forms.field.validation.numPages.positive')
        ],
        char_max_10: [
          v => (!v ||v.length <= 10) || this.$t('forms.field.validation.char.max', {max: 10}),
        ],
        char_max_30: [
          v => (!v ||v.length <= 30) || this.$t('forms.field.validation.char.max', {max: 30}),
        ],
        char_max_40: [
          v => (!v ||v.length <= 40) || this.$t('forms.field.validation.char.max', {max: 40}),
        ],
        char_max_50: [
          v => (!v ||v.length <= 50) || this.$t('forms.field.validation.char.max', {max: 50}),
        ],
        char_max_60: [
          v => (!v ||v.length <= 60) || this.$t('forms.field.validation.char.max', {max: 60}),
        ],
        char_max_70: [
          v => (!v ||v.length <= 70) || this.$t('forms.field.validation.char.max', {max: 70}),
        ],
        char_max_80: [
          v => (!v ||v.length <= 80) || this.$t('forms.field.validation.char.max', {max: 80}),
        ],
        char_max_100: [
          v => (!v ||v.length <= 100) || this.$t('forms.field.validation.char.max', {max: 100}),
        ],
        char_max_120: [
          v => (!v ||v.length <= 120) || this.$t('forms.field.validation.char.max', {max: 120}),
        ],
        char_max_180: [
          v => (!v || v.length <= 180) || this.$t('forms.field.validation.char.max', { max: 180 })
        ],
        char_max_150: [
          v => (!v ||v.length <= 150) || this.$t('forms.field.validation.char.max', {max: 150}),
        ],
        char_max_200: [
          v => (!v ||v.length <= 200) || this.$t('forms.field.validation.char.max', {max: 200}),
        ],
        char_max_500: [
          v => (!v || v.length <= 500) || this.$t('forms.field.validation.char.max', { max: 500 })
        ],
        char_max_250: [
          v => (!v ||v.length <= 250) || this.$t('forms.field.validation.char.max', {max: 250}),
        ],
        char_max_300: [
          v => (!v || v.length <= 300) || this.$t('forms.field.validation.char.max', {max: 300}),
        ],
        char_max_400: [
          v => (!v || v.length <= 400) || this.$t('forms.field.validation.char.max', {max: 400}),
        ],
        char_max_2000: [
          v => (!v || v.length <= 2000) || this.$t('forms.field.validation.char.max', {max: 2000}),
        ],
        char_max_3500: [
          v => (!v || v.length <= 3500) || this.$t('forms.field.validation.char.max', {max: 3500}),
        ],
        char_required_max_55: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 55) || this.$t('forms.field.validation.char.max', {max: 55}),
        ],
        char_required_max_15: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 15) || this.$t('forms.field.validation.char.max', {max: 15}),
        ],
        char_required_max_100: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 100) || this.$t('forms.field.validation.char.max', {max: 100}),
        ],
        char_required_max_130: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 130) || this.$t('forms.field.validation.char.max', {max: 130}),
        ],
        char_required_max_120: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 120) || this.$t('forms.field.validation.char.max', { max: 120 })
        ],
        char_required_max_170: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 170) || this.$t('forms.field.validation.char.max', {max: 170}),
        ],
        char_required_max_180: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 180) || this.$t('forms.field.validation.char.max', { max: 180 })
        ],
        char_required_max_200: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 200) || this.$t('forms.field.validation.char.max', {max: 200}),
        ],
        char_required_max_220: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 220) || this.$t('forms.field.validation.char.max', {max: 220}),
        ],
        char_required_max_250: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 250) || this.$t('forms.field.validation.char.max', {max: 250}),
        ],
        char_required_max_6500: [
          v => !!v || this.$t('forms.field.validation.required'),
          v => (!!v && v.length <= 6500) || this.$t('forms.field.validation.char.max', {max: 6500}),
        ]
      }
    };
  },
  methods: {
    dniValueRulesFunction(v) {
      let is_7_digits = /^-?[\d.]{7}(?:e-?\d+)?$/;
      let is_8_digits = /^-?[\d.]{8}(?:e-?\d+)?$/;
      let is_letter = /^[A-Za-z]$/;
      let is_passport = /^[a-z0-9]{7,12}$/i;
      switch (this.investigator.person.id_number.type) {
        case "dni":
          if (
            v.length === 9 &&
            is_8_digits.test(v.substr(0, 8)) &&
            is_letter.test(v[8])
          ) {
            return true;
          } else {
            return this.$t('forms.field.validation.dni.format')
          }
        case "nie":
          if (
            v.length === 9 &&
            is_letter.test(v[0]) &&
            is_7_digits.test(v.substr(1, 7)) &&
            is_letter.test(v[8])
          ) {
            return true;
          } else {
            return this.$t('forms.field.validation.nie.format')
          }
        case "passport":
          if (is_passport.test(v)) {
            return true;
          } else {
            return this.$t('forms.field.validation.passport.format')
          }
        default:
          return this.$t('forms.field.validation.type')
      }
    },

    range(minNum, maxNum) {
      return v =>  (v !== "" && v <= maxNum && v >= minNum) || this.$t('form.validation.range') + ' [' + minNum + '-' + maxNum + ']';
    },

    telephoneRuleFunction(v) {
      if (v !== "" && v !== undefined && v !== null) {
        let phoneNum;
        if (typeof v !== "number") {
          phoneNum = v.replace(/[^\d]/g, "");
        } else {
          phoneNum = v.toString();
        }
        if (
          phoneNum.length > 6 &&
          phoneNum.length < 16 &&
          !v.toString().match(/[a-z]/i)
        ) {
          return true;
        } else {
          return this.$t('forms.field.validation.telephone.format')
        }
      } else {
        return this.$t('forms.field.validation.required');
      }
    },
    optionalTelephoneRuleFunction(v) {
      if (v !== "" && v !== undefined && v !== null) {
        let phoneNum;
        if (typeof v !== "number") {
          phoneNum = v.replace(/[^\d]/g, "");
        } else {
          phoneNum = v.toString();
        }
        if (
            phoneNum.length > 6 &&
            phoneNum.length < 16 &&
            !v.toString().match(/[a-z]/i)
        ) {
          return true;
        } else {
          return this.$t('forms.field.validation.telephone.format')
        }
      } else {
        return true;
      }
    }
  }
};
